import { facilityLabel as sharedFacilityLabel } from "encamp-shared/src/waste/shippingDocumentLabels";
import { ShippingDocumentKind } from "generated-graphql/graphql";

import { type ManifestReviewRow } from "./api";

export function isBillOfLadingRow(row: Pick<ManifestReviewRow, "documentKind">): boolean {
  return row.documentKind === ShippingDocumentKind.BillOfLading;
}

export function facilityLabel(
  row: Pick<ManifestReviewRow, "documentKind" | "facilityId" | "facilityName" | "facilityEpaId">
): string {
  return sharedFacilityLabel(row, row.facilityEpaId ?? "—");
}
